<template>
    <div class="uk-container uk-container-expand uk-margin-top card-scrollable">
        <div class="uk-grid-column-small uk-grid-row-large uk-child-width-1-2@m" uk-grid v-if="!consist(user_cred.roles, ['user-marketing'])">
            <div v-if="getRole() !== 'supervisor'">
                <div v-if="isShow">
                    <div uk-grid>
                        <div v-if="worker" class="uk-width-auto uk-margin-auto uk-margin-auto-vertical">
                            <img
                                @onerror="`${images}/avatar.svg`"
                                style="height: 100px; width: 100px;"
                                :src="worker.user.photos ? `${path_user_image + worker.user.photos}` : `${images}/avatar.svg`"
                                class="profile-photo uk-border-circle"
                            >
                        </div>
                        <div v-else class="uk-width-auto uk-margin-auto uk-margin-auto-vertical">
                            <img :src="`${images}/avatar.svg`" class="profile-photo">
                        </div>
                        <div class="uk-width-expand uk-margin-auto uk-margin-auto-vertical">
                            <div class="applicant_name"><h4><span class="uk-text-bold">{{ worker ? worker.user.fullname : 'Nihil' }}</span></h4></div>
                            <span>Job Role: {{ worker ? worker.job_partner.role.name : 'Nihil' }}</span><br>
                            <span>Company: {{ worker ? worker.company.name : 'Nihil' }}</span><br>
                            <span>Office: {{ worker ? worker.company_office.name : 'Nihil' }}</span><br>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="location-header" style="cursor:pointer" @click="showModal('attendance-filter')">
                        <img :src="`${images}/mi_filter.svg`" alt="" width="20"> Select filter
                    </div>
                </div>
                <h4 v-if="isShow" class="title">Attendance history of <span class="uk-text-bold">{{ worker ? worker.user.fullname : 'Nihil' }}</span></h4>
            </div>
            <div v-else>
                <div v-if="isShow">
                    <div class="location-header">
                        <img :src="`${images}/shipper-location.png`" alt="" width="20"> {{ company_office.city || 'n/a' }}
                    </div>
                    <div class="location-header">
                        <img :src="`${images}/shipper-storage.png`" alt="" width="20"> {{ company_office.name || 'n/a' }}
                    </div>
                </div>
            </div>
            <div>
                <div style="overflow:auto">
                    <div class="report-download" style="cursor:pointer; float:right" @click="$router.back()">
                        <img :src="`${images}/cross.svg`" alt="" width="25">
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-flex uk-flex-between uk-margin-remove-top" uk-grid>
            <div class="uk-inline">
                <div class="uk-inline uk-margin-right" v-show="isShow">
                    <div class="location-header" style="cursor:pointer" @click="showModal('attendance-filter')">
                        <img :src="`${images}/mi_filter.svg`" alt="" width="20">
                        {{ moment(meta.start_date).format('DD MMM YYYY') + (meta.end_date ? (' - ' + moment(meta.end_date).format('DD MMM YYYY')) : '')}},
                        {{ company_office.city ? (company_office.city) : 'All Cities' }},
                        {{ company_office.name ? company_office.name : 'All Office' }}
                    </div>
                </div>
                <div class="uk-inline uk-margin-right" v-show="isShow">
                    <select
                        name="Updated By Filter"
                        class="uk-select"
                        id="form-stacked-select"
                        v-model="meta.updated_filter"
                        @change="(e) => changeMeta(e, 'updated_filter')"
                    >
                        <option value="" disabled selected>Select attendance</option>
                        <option :value="null">All Attendance</option>
                        <option :value="true">Updated Attendance</option>
                    </select>
                </div>
                <div class="uk-inline uk-margin-small-bottom" v-show="isShow">
                    <select
                        name="Sort"
                        class="uk-select"
                        id="form-stacked-select"
                        v-model="meta.sort"
                        @change="(e) => changeMeta(e, 'sort')"
                    >
                        <option :value="-1">Latest</option>
                        <option :value="1">Oldest</option>
                    </select>
                </div>
            </div>
            <div class="uk-inline">
                <div>
                    <div>
                        <button
                            v-if="$can('EDIT', 'worker-attendance')"
                            class="uk-button uk-button-primary uk-border-rounded"
                            type="button"
                            @click="showModal('confirmation-lock')"
                        >
                            <span class="uk-margin-small-right"><img :src="`${images}/lock.svg`" alt="" width="18"></span>
                            Lock
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="consist(user_cred.roles, ['superadmin-tech','superadmin-product','admin-bd','admin-client'])">
                <!-- <div class="uk-inline" v-show="isShow != ''">
                    <button class="uk-button uk-button-primary uk-border-rounded" @click="checkRecap">Generate Salary</button>
                </div> -->
            </div>
        </div>

        <div class="uk-card uk-card-default uk-margin" v-show="isShow" v-if="!consist(user_cred.roles, ['user-marketing'])">
            <div class="uk-overflow-auto">
                <table class="uk-table uk-table-medium uk-table-striped">
                    <thead>
                        <tr>
                            <th class="uk-table-expand uk-text-center">Work Date</th>
                            <th class="uk-text-center">No KTP</th>
                            <th class="uk-text-center">Mitra ID</th>
                            <th class="uk-table-expand uk-text-center">Office</th>
                            <th class="uk-text-center">Check-In<br>Time</th>
                            <th class="uk-text-center">Check-Out<br>Time</th>
                            <th class="uk-text-center">Normal<br>Worktime<br>(hrs)</th>
                            <th class="uk-text-center">Overtime Calculated<br>(hrs)</th>
                            <th class="uk-text-center">Overtime Accepted<br>(hrs)</th>
                            <th class="uk-text-center">Overall<br>Worktime<br>(hrs)</th>
                            <!-- <th class="uk-text-center">Absent<br>(hrs)</th> -->
                            <th class="uk-text-center">Leaves<br>(hrs)</th>
                            <!-- <th class="uk-text-center">Total<br>Payment<br>(Rp)</th> -->
                            <th class="uk-text-center">Distance Checkin<br>(Meter)</th>
                            <th class="uk-text-center">Distance Checkout<br>(Meter)</th>
                            <th class="uk-table-expand uk-text-center">Check-In<br>Notes</th>
                            <th class="uk-table-expand uk-text-center">Check-Out<br>Notes</th>
                            <th class="uk-table-expand uk-text-center">Attendance Method</th>
                            <th class="uk-table-expand uk-text-center">Attendance Type</th>
                            <th class="uk-text-center">Photo/<br>Location</th>
                            <th class="uk-text-center">Updated<br>By</th>
                            <th
                                v-if="$can('EDIT', 'worker-attendance') || $can('DELETE', 'worker-attendance')"
                                class="uk-text-center"
                            >Action</th>
                        </tr>
                    </thead>
                    <tbody v-if="recaps.docs.length>0">
                        <tr v-for="(worker, i) in recaps.docs" :key="i">
                            <td class="uk-text-center">{{ formatDateNew(worker.date) }}</td>
                            <td class="uk-text-center">{{ worker.user && worker.user.identity_number ? worker.user.identity_number : '-' }}</td>
                            <td class="uk-text-center">{{ worker.job_partner && worker.job_partner.employee_id ? worker.job_partner.employee_id : '-' }}</td>
                            <td class="uk-text-center">{{ worker.company_office && worker.company_office.name ? worker.company_office.name : '-' }}</td>
                            <td class="uk-text-center">{{ formatHourMinute(worker.checkin_time) }}</td>
                            <td class="uk-text-center">{{ worker.checkout_time ? formatHourMinute(worker.checkout_time) : '-' }}</td>
                            <td class="uk-text-center">{{ formatAbsolute(worker.normal_work_hour) }}</td>
                            <td class="uk-text-center">{{ formatAbsolute(worker.overtime_work_hour) }}</td>
                            <td class="uk-text-center">{{ formatAbsolute(worker.overtime_work_hour_spv) }}</td>
                            <td class="uk-text-center">{{ calculateTotalWorkTime(worker.normal_work_hour, worker.overtime_work_hour_spv) }}</td>
                            <!-- <td class="uk-text-center">{{ worker.absent_hour || '-' }}</td> -->
                            <td class="uk-text-center">{{ formatAbsolute(worker.leaves_hour) }}</td>
                            <!-- <td v-if="worker.checkin_time == null || worker.checkout_time == null" class="uk-text-center"> - </td>
                            <td v-else class="uk-text-center">{{ calculateFee(worker) }}</td> -->
                            <td class="uk-text-center">{{ worker.distance_meter_checkin !== '-' ? formatCurrency(worker.distance_meter_checkin) : '-' }}</td>
                            <td class="uk-text-center">{{ worker.distance_meter_checkout !== '-' ? formatCurrency(worker.distance_meter_checkout) : '-' }}</td>
                            <td class="uk-text-left" style="font-size: 14px">{{ worker.checkin_notes }}</td>
                            <td class="uk-text-left" style="font-size: 14px">{{ worker.checkout_notes }}</td>
                            <td class="uk-text-center" style="font-size: 14px">{{ filterAttendanceMethods(worker.attendance_method) }}</td>
                            <td class="uk-text-center" style="font-size: 14px">{{ attendanceType(worker) }}</td>
                            <td class="uk-text-center">
                                <a
                                    v-if="worker.attendance_method === 2"
                                    href="javascript:void(0)"
                                    @click="viewPhotoLocation(worker)"
                                    rel="noopener noreferrer"
                                >View</a>
                                <div v-else>No Photo/Location</div>
                            </td>
                            <td class="uk-text-center">{{ worker.updated_by ? worker.updated_by : "-" }}</td>
                            <td v-if="$can('EDIT', 'worker-attendance') || $can('DELETE', 'worker-attendance')">
                                <!-- editable button -->
                                <div v-if="worker.status != 1" class="uk-flex">
                                    <button
                                        v-if="$can('EDIT', 'worker-attendance')"
                                        class="action-button uk-button-primary uk-border-rounded"
                                        @click="editAttendData(worker)"
                                    >Edit</button>
                                    <button
                                        v-if="$can('DELETE', 'worker-attendance')"
                                        class="action-button uk-button-primary uk-border-rounded"
                                        @click="deleteAttendData(worker)"
                                    >Delete</button>
                                </div>
                                <!-- disabled button -->
                                <div v-else class="uk-flex">
                                    <button
                                        v-if="$can('EDIT', 'worker-attendance')"
                                        class="action-button uk-border-rounded"
                                        style="background:#979797"
                                        disabled
                                    >Edit</button>
                                    <button
                                        v-if="$can('DELETE', 'worker-attendance')"
                                        class="action-button uk-border-rounded"
                                        style="background:#979797"
                                        disabled
                                    >Delete</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <empty-table v-else :colspan="19"/>
                </table>
            </div>
            <pagination
                :total-data="recaps.totalDocs"
                :change-limit="changeLimit"
                :change-page="changePage"
            />
        </div>

        <div id="date-filter" class="date-filter" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('date-filter')"></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title uk-text-center">Input Date Range for Which you Want to See Details</h2>
                </div>
                <div class="uk-modal-body">
                    <div class="uk-margin">
                        <label class="uk-form-label" for="form-stacked-text">From</label>
                        <div class="uk-form-controls">
                            <datepicker
                                name="Start Date"
                                placeholder="dd/mm/yyy"
                                input-class="uk-input"
                                v-model="meta.start_date"
                                :disabled-dates="disabled_start_date"
                            ></datepicker>
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="uk-form-label" for="form-stacked-text">To (optional)</label>
                        <div class="uk-form-controls">
                            <datepicker
                                name="End Date"
                                placeholder="dd/mm/yyy"
                                input-class="uk-input"
                                v-model="meta.end_date"
                            ></datepicker>
                        </div>
                    </div>
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-primary uk-margin-small-left" type="button" @click="setDate">Apply</button>
                </div>
            </div>
        </div>

        <div id="attendance-filter" class="attendance-filter" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('location-filter')"></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title uk-text-center">Select filter for attendance list</h2>
                </div>
                <div class="uk-modal-body">
                    <div class="uk-margin">
                        <label class="uk-form-label" for="form-stacked-text">From</label>
                        <div class="uk-form-controls">
                            <datetime
                                id="start_date"
                                name="start_date"
                                input-class="uk-input"
                                placeholder="dd/mm/yyy"
                                type='date'
                                v-model="meta.start_date"
                                :max-datetime="datetime.now().toISODate()"
                                value-zone="Asia/Jakarta"
                                zone="Asia/Jakarta"
                            ></datetime>
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="uk-form-label" for="form-stacked-text">To (optional)</label>
                        <div class="uk-form-controls">
                            <datetime
                                id="end_date"
                                name="end_date"
                                input-class="uk-input"
                                placeholder="dd/mm/yyy"
                                type='date'
                                v-model="meta.end_date"
                                :min-datetime="datetime.fromISO(meta.start_date).plus({days: 1}).toISODate()"
                                :max-datetime="datetime.now().toISODate()"
                                value-zone="Asia/Jakarta"
                                zone="Asia/Jakarta"
                            ></datetime>
                        </div>
                    </div>
                    <div v-if="meta.start_date" class="uk-margin">
                        <label class="uk-form-label" for="form-stacked-select-1">City</label>
                        <div class="uk-form-controls">
                            <select
                                name="Office City"
                                class="uk-select"
                                id="form-stacked-select-1"
                                v-model="selected_city"
                                @change="filterOffice"
                            >
                                <!-- <option value="" disabled selected>Choose City</option> -->
                                <option value="all" selected>All Cities</option>
                                <option v-for="(city, index) in cities" :key="index" :value="city">{{ city }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="uk-margin" v-if="selected_city != ''">
                        <label class="uk-form-label" for="form-stacked-select-2">Office</label>
                        <div class="uk-form-controls">
                            <select
                                name="Office Property"
                                class="uk-select"
                                id="form-stacked-select-2"
                                v-model="company_office"
                            >
                                <!-- <option value="" disabled selected>Choose Property</option> -->
                                <option value="all" selected>All Offices</option>
                                <option v-for="(office, index) in filtered_offices" :key="index" :value="office">{{ office.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-primary uk-margin-small-left" type="button" @click="applyFilter">Apply</button>
                </div>
            </div>
        </div>

        <div id="location-filter" class="location-filter" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('location-filter')"></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title uk-text-center">Input property for which you want to see details</h2>
                </div>
                <div class="uk-modal-body">
                    <div class="uk-margin">
                        <label class="uk-form-label" for="form-stacked-select">City</label>
                        <div class="uk-form-controls">
                            <select
                                name="Office City"
                                class="uk-select"
                                id="form-stacked-select"
                                v-model="selected_city"
                                @change="filterOffice"
                            >
                                <option value="" disabled selected>Choose City</option>
                                <option v-for="(city, index) in cities" :key="index" :value="city">{{ city }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="uk-margin" v-if="selected_city != ''">
                        <label class="uk-form-label" for="form-stacked-select">Property</label>
                        <div class="uk-form-controls">
                            <select
                                name="Office Property"
                                class="uk-select"
                                id="form-stacked-select"
                                v-model="company_office"
                            >
                                <option value="" disabled selected>Choose Property</option>
                                <option v-for="(office, index) in filtered_offices" :key="index" :value="office">{{ office.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-primary uk-margin-small-left" type="button" @click="setLocation">Apply</button>
                </div>
            </div>
        </div>

        <div id="month-filter" class="month-filter" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('month-filter')"></button>
                <div class="uk-modal-header">
                    <h2 v-if="reportMonthly && userReport" class="uk-modal-title uk-text-center">Choose the data for user monthly report</h2>
                    <h2 v-else-if="reportMonthly" class="uk-modal-title uk-text-center">Choose the data for monthly report</h2>
                    <h2 v-else-if="userReport" class="uk-modal-title uk-text-center">Choose the data for user weekly report</h2>
                    <h2 v-else class="uk-modal-title uk-text-center">Choose the data for weekly report</h2>
                </div>
                <div class="uk-modal-body">
                    <div class="uk-margin" v-if="userReport">
                        <label class="uk-form-label" for="form-stacked-select">User</label>
                        <div class="uk-form-controls">
                            <select
                                name="User Name"
                                class="uk-select"
                                id="form-stacked-select"
                                v-model="userName"
                            >
                                <option value="" disabled selected>Select user</option>
                                <option v-for="(user, index) in userList" :key="index" :value="user.fullname">{{ user.fullname }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="uk-form-label" for="form-stacked-select">Month</label>
                        <div class="uk-form-controls">
                            <select
                                name="Month Filter"
                                class="uk-select"
                                id="form-stacked-select"
                                v-model="selected_month"
                                @change="(e) => changeMeta(e, 'month')"
                            >
                                <option value="" disabled selected>Select month</option>
                                <option value=1>Januari</option>
                                <option value=2>Februari</option>
                                <option value=3>Maret</option>
                                <option value=4>April</option>
                                <option value=5>Mei</option>
                                <option value=6>Juni</option>
                                <option value=7>Juli</option>
                                <option value=8>Agustus</option>
                                <option value=9>September</option>
                                <option value=10>Oktober</option>
                                <option value=11>November</option>
                                <option value=12>Desember</option>
                            </select>
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="uk-form-label" for="form-stacked-select">Year</label>
                        <div class="uk-form-controls">
                            <select
                                name="Year Filter"
                                class="uk-select"
                                id="form-stacked-select"
                                v-model="selected_year"
                                @change="(e) => changeMeta(e, 'year')"
                            >
                                <option value="" disabled selected>Select year</option>
                                <option value=2020>2020</option>
                                <option value=2021>2021</option>
                                <option value=2022>2022</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <!-- <download-excel
                        class="uk-button uk-button-primary uk-margin-small-left"
                        :fetch = "downloadDataWeekly"
                        :fields = "json_fields_weekly_report"
                        :before-generate = "startDownload"
                        :before-finish = "finishDownload"
                        :name = "generateWeeklyFileName()"
                    > Apply</download-excel> -->
                    <div v-if="!reportMonthly" class="uk-button uk-button-primary uk-margin-small-left" @click="downloadNewExcelMonthly">
                        Apply
                    </div>
                    <div v-else class="uk-button uk-button-primary uk-margin-small-left" @click="downloadNewDaytoDayExcelMonthly">
                        Apply
                    </div>
                </div>
            </div>
        </div>

        <div id="show-detail" class="show-detail" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('show-detail')"></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title uk-text-center">{{ selected_data.user.fullname }} Attendance on {{ formatDateNew(selected_data.checkin_time) }}</h2>
                </div>
                <div class="uk-modal-body">
                    <div class="uk-margin">
                        <div class="uk-width-1-1 uk-column-1-2@m">
                            <label class="uk-form-label" for="form-stacked-text">Location</label>
                            <div class="uk-form-controls">
                                <input
                                    name="Company Office"
                                    class="uk-input"
                                    id="form-stacked-text"
                                    type="text"
                                    :placeholder="`${selected_data.company_office.code} ${selected_data.company_office.name} ${selected_data.company_office.city}`"
                                    disabled
                                >
                            </div>
                            <label class="uk-form-label" for="form-stacked-text">Role</label>
                            <div class="uk-form-controls">
                                <input
                                    name="Role"
                                    class="uk-input"
                                    id="form-stacked-text"
                                    type="text"
                                    :placeholder="`${selected_data.job_partner.role != null ? selected_data.job_partner.role.name : '-'}`"
                                    disabled
                                >
                            </div>
                        </div>
                        <div class="uk-width-1-1 uk-column-1-2@m">
                            <label class="uk-form-label" for="form-stacked-text">Payment Unit</label>
                            <div class="uk-form-controls">
                                <input
                                    name="Payment Unit"
                                    class="uk-input"
                                    id="form-stacked-text"
                                    type="text"
                                    :placeholder="selected_data.fee_normal_unit || '-'"
                                    disabled
                                >
                            </div>
                            <br>
                            <div class="uk-form-controls">
                                <input
                                    name="Break Hour"
                                    class="uk-checkbox"
                                    id="form-stacked-text"
                                    type="checkbox"
                                    v-model="selected_data.breakhour_include"
                                    disabled
                                > Break-Hour Included
                            </div>
                        </div>
                        <div class="uk-width-1-1 uk-column-1-2@m">
                            <label class="uk-form-label" for="form-stacked-text">Check-In Time</label>
                            <div class="uk-form-controls">
                                <datetime
                                    input-class="uk-input"
                                    type="datetime"
                                    name="Check In Time"
                                    v-model="selected_data.checkin_time"
                                    placeholder="-"
                                    @input="adjustCheckInTime"
                                ></datetime>
                            </div>
                            <label class="uk-form-label" for="form-stacked-text">Check-Out Time</label>
                            <div class="uk-form-controls">
                                <datetime
                                    input-class="uk-input"
                                    type="datetime"
                                    name="Check Out Time"
                                    v-model="selected_data.checkout_time"
                                    placeholder="-"
                                    @input="adjustCheckOutTime"
                                ></datetime>
                            </div>
                        </div>
                        <span class="uk-text-small uk-text-danger" v-show="timeIsInvalid">Re-check time input!</span>
                        <div class="uk-width-1-1 uk-column-1-2@m">
                            <label class="uk-form-label" for="form-stacked-text">Normal Worktime (hrs)</label>
                            <div class="uk-form-controls">
                                <input
                                    name="Normal Worktime"
                                    class="uk-input"
                                    id="form-stacked-text"
                                    type="text"
                                    :placeholder="formatAbsolute(selected_data.normal_work_hour)"
                                    disabled
                                >
                            </div>
                            <label class="uk-form-label" for="form-stacked-text">Distance Check-in (meter)</label>
                            <div class="uk-form-controls">
                                <input
                                    name="Distance Check-in"
                                    class="uk-input"
                                    id="form-stacked-text"
                                    type="text"
                                    :placeholder="formatCurrency(selected_data.distance_meter_checkin)"
                                    disabled
                                >
                            </div>
                            <!-- <label class="uk-form-label" for="form-stacked-text">Normal Worktime Payment (Rp)</label>
                            <div class="uk-form-controls">
                                <input
                                    name="Normal Worktime Fee"
                                    class="uk-input"
                                    id="form-stacked-text"
                                    type="text"
                                    :placeholder="selected_data.fee_normal_hourly"
                                    disabled
                                >
                            </div> -->
                        </div>
                        <div class="uk-width-1-1 uk-column-1-2@m">
                            <label class="uk-form-label" for="form-stacked-text">Overtime (hrs)</label>
                            <div class="uk-form-controls">
                                <input
                                    name="Overtime"
                                    class="uk-input"
                                    id="form-stacked-text"
                                    type="text"
                                    v-model="selected_data.overtime_work_hour_spv"
                                    :disabled="selected_data.is_half_day"
                                >
                            </div>
                            <label class="uk-form-label" for="form-stacked-text">Distance Check-out (meter)</label>
                            <div class="uk-form-controls">
                                <input
                                    name="Distance Check-out"
                                    class="uk-input"
                                    id="form-stacked-text"
                                    type="text"
                                    :placeholder="formatCurrency(selected_data.distance_meter_checkout)"
                                    disabled
                                >
                            </div>
                            <!-- <label class="uk-form-label" for="form-stacked-text">Overtime Payment (Rp)</label>
                            <div class="uk-form-controls">
                                <input
                                    name="Overtime Fee"
                                    class="uk-input"
                                    id="form-stacked-text"
                                    type="text"
                                    :placeholder="selected_data.fee_overtime_hourly"
                                    disabled
                                >
                            </div> -->
                        </div>
                        <div class="uk-width-1-1 uk-column-1-2@m">
                            <label class="uk-form-label" for="form-stacked-text">Check-in Notes</label>
                            <div class="uk-form-controls">
                                <input
                                    name="Checkin Notes"
                                    class="uk-input"
                                    id="form-stacked-text"
                                    :placeholder="selected_data.checkin_notes"
                                    disabled
                                >
                            </div>
                            <label class="uk-form-label" for="form-stacked-text">Check-out Notes</label>
                            <div class="uk-form-controls">
                                <input
                                    name="Check-out Notes"
                                    class="uk-input"
                                    id="form-stacked-text"
                                    type="text"
                                    :placeholder="selected_data.checkout_notes"
                                    disabled
                                >
                            </div>
                            <!-- <label class="uk-form-label" for="form-stacked-text">Overtime Payment (Rp)</label>
                            <div class="uk-form-controls">
                                <input
                                    name="Overtime Fee"
                                    class="uk-input"
                                    id="form-stacked-text"
                                    type="text"
                                    :placeholder="selected_data.fee_overtime_hourly"
                                    disabled
                                >
                            </div> -->
                        </div>
                        <label class="uk-form-label" for="form-stacked-text">Overall Worktime (hrs)</label>
                        <div class="uk-form-controls">
                            <input
                                name="Total Work Time"
                                class="uk-input"
                                id="form-stacked-text"
                                type="text"
                                :placeholder="calculateTotalWorkTime(selected_data.normal_work_hour, selected_data.overtime_work_hour_spv)"
                                disabled
                            >
                        </div>
                        <div class="uk-width-1-1 uk-column-1-1@m">
                            <!-- <label class="uk-form-label" for="form-stacked-text">Absent (hrs)</label>
                            <div class="uk-form-controls">
                                <input
                                    name="Absent"
                                    class="uk-input"
                                    id="form-stacked-text"
                                    type="text"
                                    v-model="selected_data.absent_hour"
                                >
                            </div> -->
                            <label class="uk-form-label" for="form-stacked-text">Leaves (hrs)</label>
                            <div class="uk-form-controls">
                                <input
                                    name="Leaves"
                                    class="uk-input"
                                    id="form-stacked-text"
                                    type="text"
                                    v-model="selected_data.leaves_hour"
                                >
                            </div>
                        </div>
                        <!-- <label class="uk-form-label" for="form-stacked-text">Total Payment (Rp)</label>
                        <div class="uk-form-controls">
                            <input
                                name="Total Payment"
                                class="uk-input"
                                id="form-stacked-text"
                                type="text"
                                :placeholder="calculateFee(selected_data)"
                                disabled
                            >
                        </div> -->
                        <div>
                            <br>
                            Photo/Location
                            <br>
                            <a
                                v-if="selected_data.attendance_method === 2"
                                href="javascript:void(0)"
                                @click="viewPhotoLocation(selected_data)"
                                rel="noopener noreferrer"
                            >View</a>
                            <div v-else>No Photo/Location</div>
                        </div>
                        <div class="uk-width-1-1 uk-column-1-1@m">
                            <label class="uk-form-label" for="form-stacked-text">Attendance Method</label>
                            <select class="uk-select" v-model="selected_data.attendance_method">
                                <option :value="0">Scanned by employer</option>
                                <option :value="1">Self-scan on Office / Warehouse</option>
                                <option :value="2">Photo upload</option>
                                <option :value="3">Mitra Request</option>
                            </select>
                        </div>
                        <div class="uk-width-1-1 uk-column-1-1@m">
                            <label class="uk-form-label" for="form-stacked-text">Attendance Type By</label>
                            <div class="uk-form-controls">
                                <input
                                    name="HO"
                                    class="uk-checkbox"
                                    id="form-stacked-text"
                                    type="checkbox"
                                    v-model="selected_data.is_replacement_day"
                                > HO
                            </div>
                            <div class="uk-form-controls">
                                <input
                                    name="Half Day"
                                    class="uk-checkbox"
                                    id="form-stacked-text"
                                    type="checkbox"
                                    v-model="selected_data.is_half_day"
                                    :disabled="selected_data.overtime_work_hour_spv > 0"
                                > Half Day
                            </div>
                        </div>
                        <div>
                            <br>
                            Edited By
                            <br>
                            {{ selected_data.updated_by }}
                        </div>
                    </div>
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button :disabled="timeIsInvalid || incompleteForm" class="uk-button uk-button-primary uk-margin-small-left" type="button" @click="updateDataConfirm">Save</button>
                </div>
            </div>
        </div>

        <div id="confirmation-edit-box" class="confirmation-edit-box" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('confirmation-edit-box')"></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title uk-text-left">Do you want to edit?</h2>
                </div>
                <div class="uk-modal-body">
                    <p>You’re about to edit {{ selected_data.user.fullname }} attendance for {{ formatDateNew(selected_data.checkin_time) }}!
                        After you edit, this attendance will be locked for payment.</p>
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-danger uk-margin-small-left" type="button" @click="declineConfirmationEdit">No</button>
                    <button class="uk-button uk-button-primary uk-margin-small-left" type="button" @click="acceptConfirmationEdit">Yes</button>
                </div>
            </div>
        </div>

        <div id="confirmation-edit-box-2" class="confirmation-edit-box-2" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('confirmation-edit-box-2')"></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title uk-text-left">Are you sure?</h2>
                </div>
                <div class="uk-modal-body">
                    <p>You’re about to edit {{ selected_data.user.fullname }} attendance for {{ formatDateNew(selected_data.checkin_time) }}!
                        After you edit, this attendance will be locked for payment.</p>
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-danger uk-margin-small-left" type="button" @click="declineConfirmationEdit2">No</button>
                    <button class="uk-button uk-button-primary uk-margin-small-left" type="button" @click="acceptConfirmationEdit2">Yes</button>
                </div>
            </div>
        </div>

        <div id="confirmation-heads-up" class="confirmation-heads-up" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('confirmation-heads-up')"></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title uk-text-center">Heads Up! This attendance will be locked for payment</h2>
                </div>
                <div class="uk-modal-body uk-text-center">
                    <button class="uk-button uk-button-danger uk-margin-small-left" type="button" @click="hideModal('confirmation-heads-up')">Cancel</button>
                    <button class="uk-button uk-button-primary uk-margin-small-left" type="button" @click="lockData">Confirm</button>
                </div>
            </div>
        </div>

        <div id="confirmation-delete-box" class="confirmation-delete-box" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('confirmation-delete-box')"></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title">Confirmation</h2>
                </div>
                <div class="uk-modal-body">
                    <p>Are you sure want to Delete?</p>
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button
                        type="button"
                        class="uk-button uk-button-default uk-border-rounded uk-margin-small-left"
                        @click="hideModal('confirmation-delete-box')"
                        style="border-color: #1e87f0; color: #1e87f0"
                    >No</button>
                    <button
                        type="button"
                        class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left"
                        @click="confirmDeleteData"
                    >Yes</button>
                </div>
            </div>
        </div>

        <div id="success-edit" class="success-edit" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('success-edit')"></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title uk-text-left">Success!</h2>
                </div>
                <div class="uk-modal-body">
                    <p>{{ selected_data.user.fullname }} attendance for {{ formatDateNew(selected_data.checkin_time) }}
                        is now locked for payment.</p>
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-primary uk-margin-small-left" type="button" @click="hideModal('success-edit')">Ok</button>
                </div>
            </div>
        </div>

        <div id="download-modal" class="download-modal" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('download-modal')"></button>
                <div class="uk-modal-body">
                    <p>Pick the report's period!</p>
                    <div style="overflow:auto">
                        <div style="cursor:pointer;float:left" @click="downloadNewExcelDaily">
                            <img :src="`${images}/excel.png`" alt="" width="20">
                            Daily Report
                        </div>
                    </div>
                    <div style="overflow:auto">
                        <div style="cursor:pointer;float:left" @click="showModal('month-filter')">
                            <img :src="`${images}/excel.png`" alt="" width="20">
                            Weekly Report
                        </div>
                    </div>
                    <div style="overflow:auto">
                        <div style="cursor:pointer;float:left" @click="showModal('month-filter'); reportMonthly=true">
                            <img :src="`${images}/excel.png`" alt="" width="20">
                            Monthly Report
                        </div>
                    </div>
                    <div style="overflow:auto">
                        <div style="cursor:pointer;float:left" @click="showModal('month-filter'); userReport=true">
                            <img :src="`${images}/excel.png`" alt="" width="20">
                            User Weekly Report
                        </div>
                    </div>
                    <div style="overflow:auto">
                        <div style="cursor:pointer;float:left" @click="showModal('month-filter'); reportMonthly=true; userReport=true">
                            <img :src="`${images}/excel.png`" alt="" width="20">
                            User Monthly Report
                        </div>
                    </div>
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-primary uk-margin-small-left" type="button" @click="hideModal('download-modal')">Back</button>
                </div>
            </div>
        </div>

        <div id="warning-modal" class="warning-modal" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('warning-modal')"></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title">Warning!</h2>
                </div>
                <div class="uk-modal-body">
                    <p>There is Attendance Recap that has been included into another batch!</p>
                    <p v-if="salary_data != null">Upcoming Salary Batch summary
                        <br>Users : {{ salary_data.user_count }}
                        <br>Total Payment : {{ formatCurrency(parseInt(salary_data.total_payment)) }}
                    </p>
                </div>
                <div class="uk-modal-footer uk-text-right" v-if="salary_data != null">
                    <button class="uk-button uk-button-danger uk-modal-close uk-margin-right" type="button" @click="hideModal('warning-modal')">Cancel</button>
                    <button class="uk-button uk-button-primary" type="button" @click="showModal('salary-modal')" v-if="salary_data.user_count > 0">Continue</button>
                </div>
            </div>
        </div>

        <div id="salary-modal" class="salary-modal" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('salary-modal')"></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title">Salary Batch</h2>
                </div>
                <div class="uk-modal-body">
                    <div class="uk-margin">
                        <label class="uk-form-label" for="form-stacked-text">Salary Batch Name</label>
                        <div class="uk-form-controls">
                            <input
                                class="uk-input"
                                name="name"
                                type="text"
                                v-model="formSalary.name"
                            >
                        </div>
                    </div>
                    <p v-if="salary_data != null">Upcoming Salary Batch summary
                        <br>Users : {{ salary_data.user_count }}
                        <br>Total Payment : {{ formatCurrency(parseInt(salary_data.total_payment)) }}
                    </p>
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-danger uk-modal-close uk-margin-right" type="button" @click="hideModal('salary-modal')">Cancel</button>
                    <button class="uk-button uk-button-primary" type="button" @click="createSalaryBatch">Create</button>
                </div>
            </div>
        </div>

        <div id="photo-location-modal" class="photo-location-modal" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('salary-modal')"></button>
                <div class="uk-modal-header uk-text-center">
                    <h2 class="uk-modal-title">Attendance Photo and Location</h2>
                </div>
                <div class="uk-modal-body">
                    <div class="uk-grid-column-small uk-grid-row-large uk-child-width-1-2@s" uk-grid>
                        <div>
                            <h6>Check-in</h6>
                            <img :src="photoLocation.checkin.path ? photoLocation.checkin.path : 'https://via.placeholder.com/300x400'">
                            <GmapMap
                                style="width: 100%; height: 100px; margin-top: 20px;"
                                :zoom="10"
                                :center="photoLocation.checkin.geoloc"
                                ref="map"
                            >
                                <GmapMarker :position="photoLocation.checkin.geoloc" />
                            </GmapMap>
                        </div>
                        <div v-if="photoLocation.checkout.path !== null">
                            <h6>Check-out</h6>
                            <img :src="photoLocation.checkout.path ? photoLocation.checkout.path : 'https://via.placeholder.com/300x400'">
                            <GmapMap
                                style="width: 100%; height: 100px; margin-top: 20px;"
                                :zoom="10"
                                :center="photoLocation.checkout.geoloc"
                                ref="map"
                            >
                                <GmapMarker :position="photoLocation.checkout.geoloc" />
                            </GmapMap>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal box Confirmation -->
        <div id="confirmation-lock" class="confirmation-lock" uk-modal esc-close="false" bg-close="true">
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close @click="hideModal('confirmation-lock')"></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title uk-text-center">Confirmation</h2>
                </div>
                <div class="uk-modal-body">
                    Are you sure want to proceed?
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-danger uk-border-rounded" @click="hideModal('confirmation-lock')">No</button>
                    <button class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left" type="button" @click="lockedUser()">Yes</button>
                </div>
            </div>
        </div>
        <!-- End modal box Confirmation -->
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getUserLogin } from '@/utils/auth';
import { PREFIX_IMAGE, PREFIX_ATTENDANCE_IMAGE, PREFIX_PROFILE_IMAGE } from '@/utils/constant';
// import LabelStatus from '@/components/globals/LabelStatus';
import formatter from "@/utils/formatter";
import EmptyTable from '@/components/globals/tables/EmptyTable';
import Pagination from '@/components/globals/Pagination';
import Datepicker from 'vuejs-datepicker';
import { Datetime } from 'vue-datetime';
import {
    notificationSuccess,
    notificationDangerCustom
} from '@/utils/notification';
import { excelDownloader } from '@/utils/helper';
import { DateTime } from 'luxon';
import moment from 'moment';
moment.locale('id');

export default {
    data({ $route }) {
        return {
            datetime: DateTime,
            photoLocation: {
                checkin: {
                    path: null,
                    geoloc: {
                        lat: 0,
                        lng: 0
                    }
                },
                checkout: {
                    path: null,
                    geoloc: {
                        lat: 0,
                        lng: 0
                    }
                }
            },
            path_images: PREFIX_ATTENDANCE_IMAGE,
            path_user_image: PREFIX_PROFILE_IMAGE,
            markers: [],
            showInfo: false,
            infoWindowContext: {
                position: {
                    lat: 106.9285376,
                    lng: -6.2717952
                }
            },
            infoWindowsList: null,
            moment: moment,
            worker: null,
            isShow: true,
            meta: $route.query,
            user_profile: '',
            json_data: null,
            images: PREFIX_IMAGE,
            plans: [],
            managers: [],
            company_office: { name: $route.query.property_name, city: $route.query.property_city},
            disabled_start_date: {
                to: new Date('2020','07','01') // 1 August 2020
            },
            json_fields: {
                'WH ID': {
                    callback: (value) => {
                        return `${value.company_office.type.code} - ${value.company_office.code}`;
                    }
                },
                'WH Name': 'company_office.name',
                'Employee Name': 'user.fullname',
                'Over time (hours)': 'overtime_work_hour_spv',
                'Total Time spent (hours)': {
                    callback: (value) => {
                        return `${value.normal_work_hour + value.overtime_work_hour}`;
                    }
                }
            },
            json_fields_full: {
                'WH ID': {
                    callback: (value) => {
                        return `${value.company_office.type.code} - ${value.company_office.code}`;
                    }
                },
                'WH Name': 'company_office.name',
                'Employee Name': 'user.fullname',
                'Date': {
                    callback: (value) => {
                        return `${formatter.dateComplete(value.checkin_time)}`;
                    }
                },
                'Check-In time': {
                    callback: (value) => {
                        return `${formatter.timeComplete(value.checkin_time)}`;
                    }
                },
                'Check-Out time': {
                    callback: (value) => {
                        return `${formatter.timeComplete(value.checkout_time)}`;
                    }
                },
                'Normal Worktime (hours)': 'normal_work_hour',
                'Over time (hours)': 'overtime_work_hour_spv',
                'Absent (hours)': 'absent_hour',
                'Leaves (hours)': 'leaves_hour',
                'Total Payment (Rp)': {
                    callback: (value) => {
                        if (value.checkin_time == null || value.checkout_time == null) {
                            return '-';
                        } else {
                            const total_fee = (value.fee_normal_hourly) + (value.overtime_work_hour_spv * value.fee_overtime_hourly);
                            return total_fee;
                        }
                    }
                },
                'Notes': {
                    callback: (value) => {
                        const regex = /\bn/;
                        if (value.notes.search(regex) == 0) {
                            return '-';
                        } else {
                            return value.notes;
                        }
                    }
                },
            },
            json_fields_weekly_report: {
                'WH ID': 'wh_code',
                'WH Name': 'wh_name',
                'Week Start Date': 'start_date',
                'Week End Date': 'end_date',
                'Number of Employees': 'worker_total',
                'Normal Work Hours': 'normal_work_hour',
                'Overtime Work Hours': 'overtime_work_hour_spv'
            },
            selected_city: 'all',
            cities: [],
            filtered_offices: [],
            selected_month: '',
            selected_year: '',
            selected_data: {
                user: {},
                company: {},
                company_office: {},
                job_partner: {
                    role: {}
                }
            },
            timeIsInvalid: false,
            reportMonthly: false,
            userReport: false,
            userList: [],
            userName: '',
            salary_data: null,
            formSalary: {
                name: null,
            },
            showResult: false,
        };
    },
    components: {
        // LabelStatus,
        EmptyTable,
        Pagination,
        Datepicker,
        Datetime
    },
    computed : {
        ...mapGetters({
            company_offices: 'company_office/company_offices',
            recaps: 'mitra/recaps'
        }),
        user_cred() {
            return getUserLogin();
        },
        incompleteForm() {
            let incomplete = false;
            if (!this.selected_data.checkin_time || !this.selected_data.checkout_time) {
                incomplete = true;
            }

            return incomplete;
        }
    },
    watch: {
        meta() {
            this.meta.start_date = moment(this.meta.start_date).format('YYYY-MM-DD');
            this.meta.end_date = moment(this.meta.end_date).format('YYYY-MM-DD');
            this.getRecaps(this.meta);
        },
    },
    beforeMount() {
        if(window.UIkit.modal('.photo-location-modal')) window.UIkit.modal('.photo-location-modal').$destroy(true);
        if(window.UIkit.modal('.attendance-filter')) window.UIkit.modal('.attendance-filter').$destroy(true);
        if(window.UIkit.modal('.confirmation-edit-box')) window.UIkit.modal('.confirmation-edit-box').$destroy(true);
        if(window.UIkit.modal('.confirmation-edit-box-2')) window.UIkit.modal('.confirmation-edit-box-2').$destroy(true);
        if(window.UIkit.modal('.confirmation-heads-up')) window.UIkit.modal('.confirmation-heads-up').$destroy(true);
        if(window.UIkit.modal('.confirmation-delete-box')) window.UIkit.modal('.confirmation-delete-box').$destroy(true);
        if(window.UIkit.modal('.success-edit')) window.UIkit.modal('.success-edit').$destroy(true);
        if(window.UIkit.modal('.download-modal')) window.UIkit.modal('.download-modal').$destroy(true);
        if(window.UIkit.modal('.warning-modal')) window.UIkit.modal('.warning-modal').$destroy(true);
        if(window.UIkit.modal('.salary-modal')) window.UIkit.modal('.salary-modal').$destroy(true);
        if(window.UIkit.modal('.show-detail')) window.UIkit.modal('.show-detail').$destroy(true);
        if(window.UIkit.modal('.date-filter')) window.UIkit.modal('.date-filter').$destroy(true);
        if(window.UIkit.modal('.location-filter')) window.UIkit.modal('.location-filter').$destroy(true);
        if(window.UIkit.modal('.month-filter')) window.UIkit.modal('.month-filter').$destroy(true);
        if(window.UIkit.modal('.confirmation-lock')) window.UIkit.modal('.confirmation-lock').$destroy(true);
    },
    async mounted() {
        this.meta.worker_name = this.$route.params.user_name;
        await this.getCompanyOffice();
        this.user_profile = await this.getProfile();
        this.setCity();
    },
    async created() {
        if(!this.meta.company_office_id || this.meta.company_office_id == 'null') delete this.meta.company_office_id;
        if(!this.meta.domicile_city_id || this.meta.domicile_city_id == 'null') delete this.meta.domicile_city_id;
        await this.getRecaps(this.meta);
        this.worker = this.recaps.docs.length > 0 ? this.recaps.docs[0] : null;
    },
    methods: {
        ...mapActions({
            getCompanyOffice: 'company_office/getCompanyOffice',
            getProfile: 'auth/getProfile',
            getRecaps: 'mitra/getRecaps',
            getAllRecaps: 'mitra/getAllRecaps',
            getWeeklyReportByMonth: 'mitra/getWeeklyReportByMonth',
            getDailyReportByMonth: 'mitra/getDailyReportByMonth',
            getAllNonGroupedRecaps: 'mitra/getAllNonGroupedRecaps',
            updateRecap: 'mitra/updateRecap',
            deleteRecap: 'mitra/deleteRecap',
            getUserPartner: 'schedule/getUserPartner',
            checkRecaps: 'salary/checkRecaps',
            updateSingleLock: 'mitra/updateSingleLock',
            postCreateBatch: 'salary/postCreateBatch',
        }),
        async lockedUser() {
            try {
                for (const data of this.recaps.docs) {
                    if (!data.checkout_time) {
                        notificationDangerCustom(`There are still users who haven't checkout`);
                        this.hideModal('confirmation-lock');
                        return;
                    }
                }
                const data = {
                    company_office_id: this.worker.company_office._id,
                    user_id: this.worker.user._id,
                    job_partner_id: this.worker.job_partner._id,
                };
                const response = await this.updateSingleLock(data);
                if (response && response.status === 'OK') {
                    await this.getRecaps(this.meta);
                    notificationSuccess('User attendance has been locked!');
                } else {
                    notificationDangerCustom(`Failed to lock user attendance. "${response.message}"`);
                }
                this.hideModal('confirmation-lock');
            } catch (e) {
                notificationDangerCustom(`Failed to lock user attendance. "${e}"`);
            }
        },
        filterAttendanceMethods(status){
            switch (status) {
            case 0:
                return 'Scanned by employer spv';
            case 1:
                return 'Self-scan on office/warehouse';
            case 2:
                return 'Photo upload';
            case 3:
                return 'Mitra Request';
            default:
                return 'No Attendance Methods';
            }
        },
        attendanceType(data) {
            let type = 'Reguler';
            if (data.is_replacement_day && data.is_half_day) {
                type = 'Half Day & HO';
            } else if (data.is_replacement_day) {
                type = 'HO';
            } else if (data.is_half_day) {
                type = 'Half Day';
            }

            return type;
        },
        async viewPhotoLocation(item) {
            this.photoLocation = {
                checkin: {
                    path: null,
                    geoloc: {
                        lat: 0,
                        lng: 0
                    }
                },
                checkout: {
                    path: null,
                    geoloc: {
                        lat: 0,
                        lng: 0
                    }
                }
            };

            for (let i = 0; i < item.geoloc.length; i++){
                if (i === 0){
                    this.photoLocation.checkin.geoloc.lat = item.geoloc[i].geoloc.coordinates[1];
                    this.photoLocation.checkin.geoloc.lng = item.geoloc[i].geoloc.coordinates[0];
                    this.photoLocation.checkin.path = this.path_images + item.checkin_photo;
                }else{
                    this.photoLocation.checkout.geoloc.lat = item.geoloc[i].geoloc.coordinates[1];
                    this.photoLocation.checkout.geoloc.lng = item.geoloc[i].geoloc.coordinates[0];
                    this.photoLocation.checkout.path = this.path_images + item.checkout_photo;
                }
            }
            await window.UIkit.modal('#photo-location-modal').show();
        },
        detailCandidate(id) {
            this.$router.push('candidate/' + id);
        },
        async fetchUser(){
            const users = await this.getUserPartner({company_office_id: this.company_office._id});
            this.userList = users;
        },
        getRole() {
            return formatter.getUserRole().toLowerCase();
        },
        selectCompanyOffice(){
            this.company_office = this.company_offices.length > 0 ? this.company_offices[0] : 'n/a';
        },
        formatDate(data) {
            if (data == null) {
                return '-';
            }
            return formatter.dateComplete(data);
        },
        formatDateNew(data) {
            if (data == null) {
                return '-';
            }
            return formatter.dateCompleteNew(data);
        },
        formatHourMinute(data) {
            if (data == null) {
                return '-';
            }
            return formatter.hourMinuteOnly(data);
        },
        matchMonth(date, month) {
            month--;
            if (date.getMonth() === month) return date;

            // End of year
            if (date.getMonth() === 11 && month === 0) {
                return new Date(date.getFullYear() + 1, month, 1);
            } else if (date.getMonth() === 0 && month === 11) {
                return new Date(date.getFullYear() - 1, month + 1, 0);
            }

            // Rest of year
            if (date.getMonth() < month) {
                return new Date(date.getFullYear(), month, 1);
            } else {
                return new Date(date.getFullYear(), month + 1, 0);
            }
        },
        formatCurrency(data) {
            if (data == ('-' || null)) {
                return '-';
            }
            return formatter.thousandSeparator(data);
        },
        formatAbsolute(data) {
            return formatter.absoluteNumber(data);
        },
        changeLimit(e) {
            this.meta = {
                ...this.meta,
                limit: e.target.value
            };
        },
        changePage(value) {
            this.meta = {
                ...this.meta,
                page: value
            };
        },
        redirectPage(link) {
            window.open(link, '_blank');
        },
        async hideModal(modal_name) {
            switch(modal_name) {
            case 'confirmation-lock':
                await window.UIkit.modal('#confirmation-lock').hide();
                break;
            case 'date-filter':
                await window.UIkit.modal('#date-filter').hide();
                break;
            case 'location-filter':
                await window.UIkit.modal('#location-filter').hide();
                break;
            case 'attendance-filter':
                await window.UIkit.modal('#attendance-filter').hide();
                break;
            case 'month-filter':
                this.reportMonthly = false;
                this.userReport = false;
                await window.UIkit.modal('#month-filter').hide();
                break;
            case 'show-detail':
                await window.UIkit.modal('#show-detail').hide();
                this.selected_data= {
                    user: {},
                    company: {},
                    company_office: {},
                    job_partner: {
                        role: {}
                    }};
                this.timeIsInvalid = false;
                break;
            case 'confirmation-edit-box':
                await window.UIkit.modal('#confirmation-edit-box').hide();
                break;
            case 'confirmation-edit-box-2':
                await window.UIkit.modal('#confirmation-edit-box-2').hide();
                break;
            case 'confirmation-heads-up':
                await window.UIkit.modal('#confirmation-heads-up').hide();
                break;
            case 'confirmation-delete-box':
                await window.UIkit.modal('#confirmation-delete-box').hide();
                break;
            case 'success-edit':
                await window.UIkit.modal('#success-edit').hide();
                break;
            case 'download-modal':
                await window.UIkit.modal('#download-modal').hide();
                break;
            case 'warning-modal':
                await window.UIkit.modal('#warning-modal').hide();
                this.salary_data = null;
                break;
            case 'salary-modal':
                await window.UIkit.modal('#salary-modal').hide();
                this.salary_data = null;
                this.formSalary = {name:null};
                break;
            }
        },
        async showModal(modal_name) {
            switch(modal_name) {
            case 'confirmation-lock':
                await window.UIkit.modal('#confirmation-lock').show();
                break;
            case 'date-filter':
                this.showResult = false;
                await window.UIkit.modal('#date-filter').show();
                break;
            case 'location-filter':
                this.showResult = false;
                this.setCity();
                if (this.selected_city !== '') {
                    this.filterOffice();
                }
                await window.UIkit.modal('#location-filter').show();
                break;
            case 'attendance-filter':
                this.showResult = false;
                this.setCity();
                if (this.selected_city !== '') {
                    this.filterOffice();
                }
                await window.UIkit.modal('#attendance-filter').show();
                break;
            case 'month-filter':
                await window.UIkit.modal('#month-filter').show();
                break;
            case 'show-detail':
                await window.UIkit.modal('#show-detail').show();
                break;
            case 'confirmation-edit-box':
                await window.UIkit.modal('#confirmation-edit-box').show();
                break;
            case 'confirmation-edit-box-2':
                await window.UIkit.modal('#confirmation-edit-box-2').show();
                break;
            case 'confirmation-heads-up':
                await window.UIkit.modal('#confirmation-heads-up').show();
                break;
            case 'confirmation-delete-box':
                await window.UIkit.modal('#confirmation-delete-box').show();
                break;
            case 'success-edit':
                await window.UIkit.modal('#success-edit').show();
                break;
            case 'download-modal':
                this.fetchUser();
                await window.UIkit.modal('#download-modal').show();
                break;
            case 'warning-modal':
                await window.UIkit.modal('#warning-modal').show();
                break;
            case 'salary-modal':
                await window.UIkit.modal('#salary-modal').show();
                break;
            }
        },
        setDate() {
            if (this.meta.start_date != null && this.meta.end_date != null) {
                const start_date = new Date(this.meta.start_date);
                const end_date = new Date(this.meta.end_date);
                if (start_date > end_date) {
                    return notificationDangerCustom('End date must be greater than start date');
                }
            } else if (this.meta.start_date == null) {
                return notificationDangerCustom('Start date must be filled');
            }
            this.getRecaps(this.meta);
            this.showResult = true;
            this.hideModal('date-filter');
        },
        async downloadData() {
            const response = await this.getAllRecaps(this.meta);
            this.json_data = await this.getAllNonGroupedRecaps(this.meta);
            this.$refs.download2.$el.click();
            return response;
        },
        async downloadDataWeekly() {
            this.hideModal('month-filter');
            const response = await this.getWeeklyReportByMonth(this.meta);
            return response;
        },
        startDownload(){
            notificationSuccess('Downloading data.....');
        },
        finishDownload(){
            notificationSuccess('Data downloaded successfully');
        },
        dateFilterAsText() {
            let date_format = '';
            if (this.meta.start_date) {
                date_format = date_format + this.formatDate(this.meta.start_date);
            }
            if (this.meta.end_date) {
                if (date_format !== '') {
                    date_format = date_format + '-';
                }
                date_format = date_format + this.formatDate(this.meta.end_date);
            }
            return date_format;
        },
        generateFileName() {
            let suffixName = "";
            const officeCity = this.company_office ? this.company_office.city : '';
            const officeCode = this.company_office ? this.company_office.code : '';
            if (this.dateFilterAsText() != '' && this.company_office == '') {
                suffixName = ` (${this.dateFilterAsText()})`;
            } else if (this.dateFilterAsText() == '' && this.company_office != '') {
                suffixName = ` ${officeCity} ${officeCode}`;
            } else if (this.dateFilterAsText() != '' && this.company_office != '') {
                suffixName = ` ${officeCity} ${officeCode} (${this.dateFilterAsText()})`;
            }

            let filename = `MyRobin-Shipper Mitra Attendance Report${suffixName}.xls`;
            return filename;
        },
        generateFileNameFull() {
            let suffixName = "";
            const officeCity = this.company_office ? this.company_office.city: '';
            const officeCode = this.company_office ? this.company_office.code : '';
            if (this.dateFilterAsText() != '' && this.company_office == '') {
                suffixName = ` (${this.dateFilterAsText()})`;
            } else if (this.dateFilterAsText() == '' && this.company_office != '') {
                suffixName = ` ${officeCity} ${officeCode}`;
            } else if (this.dateFilterAsText() != '' && this.company_office != '') {
                suffixName = ` ${officeCity} ${officeCode} (${this.dateFilterAsText()})`;
            }

            let filename = `MyRobin-Shipper Mitra Attendance Details Report${suffixName}.xls`;

            return filename;
        },
        resetDate() {
            this.meta.start_date = null;
            this.meta.end_date = null;
            this.getRecaps(this.meta);
        },
        flterDateText() {
            let date_filter_text = this.dateFilterAsText();
            if (date_filter_text != '') {
                return date_filter_text;
            }
            return 'Choose date range';
        },
        setCity() {
            this.cities = [...new Set(this.company_offices.map(data => data.city))];
            this.filtered_offices = [];
        },
        filterOffice() {
            this.filtered_offices = this.company_offices.filter(data => data.city === this.selected_city);
        },
        async applyFilter() {
            if (this.meta.start_date != null && this.meta.end_date != null) {
                const start_date = new Date(this.meta.start_date);
                const end_date = new Date(this.meta.end_date);
                if (start_date > end_date) {
                    return notificationDangerCustom('End date must be greater than start date');
                }
            } else if (this.meta.start_date == null) {
                return notificationDangerCustom('Start date must be filled');
            }
            if (this.company_office === '') {
                return notificationDangerCustom('Please select one of property');
            }
            this.meta.property_city = this.company_office.city;
            this.meta.property_name = this.company_office.name;
            await this.getRecaps(this.meta);
            this.showResult = true;
            await this.hideModal('attendance-filter');
            this.isShow = true;
            this.$store.state.selected_company = this.company_office;
        },
        async setLocation() {
            if (this.company_office == '') {
                return notificationDangerCustom('Please select one of property');
            }
            this.meta.property_city = this.company_office.city;
            this.meta.property_name = this.company_office.name;
            await this.getRecaps(this.meta);
            this.showResult = true;
            await this.hideModal('location-filter');
            this.$store.state.selected_company = this.company_office;
        },
        resetLocation() {
            this.meta.property_city = null;
            this.meta.property_name = null;
            this.company_office= '';
            this.selected_city= '';
            this.cities= [];
            this.filtered_offices= [];
            this.getRecaps(this.meta);
            this.$store.state.selected_company = '';
        },
        resetFilter() {
            this.meta.property_city = null;
            this.meta.property_name = null;
            this.company_office= '';
            this.selected_city= '';
            this.cities= [];
            this.filtered_offices= [];
            this.$store.state.selected_company = '';
            this.meta.start_date = null;
            this.meta.end_date = null;
            this.getRecaps(this.meta);
            this.isShow = false;
        },
        changeMeta(e, prop) {
            this.meta = {
                ...this.meta,
                [prop]: e.target.value
            };
        },
        generateMonthlyFileName() {
            if (this.userReport) {
                return `MyRobin-Shipper Monthly Report (${this.userName} - ${this.monthName(this.selected_month)} - ${this.selected_year}).xls`;
            } else {
                return `MyRobin-Shipper Monthly Report (${this.monthName(this.selected_month)} - ${this.selected_year}).xls`;
            }
        },
        generateWeeklyFileName() {
            if (this.userReport) {
                return `MyRobin-Shipper User Weekly Report (${this.userName} -  ${this.monthName(this.selected_month)} - ${this.selected_year}).xls`;
            } else {
                return `MyRobin-Shipper Weekly Report (${this.monthName(this.selected_month)} - ${this.selected_year}).xls`;
            }
        },
        monthName(mon) {
            return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][mon - 1];
        },
        editDataTreshold(date) {
            return moment().subtract(2, "days") < moment(date);
        },
        editAttendData(data) {
            this.selected_data = {...data};

            this.showModal('confirmation-edit-box');
        },
        deleteAttendData(data) {
            this.selected_data = {...data};
            this.showModal('confirmation-delete-box');
        },
        async confirmDeleteData() {
            const res = await this.deleteRecap(this.selected_data.id);
            if (res && res.status === 'OK') {
                notificationSuccess('Daily recap deleted!');
                await this.getRecaps(this.meta);
            } else {
                notificationDangerCustom('Failed to delete recap.');
            }
            this.hideModal('confirmation-delete-box');
        },
        calculateFee(data) {
            // const worktime = parseInt(Math.abs(data.normal_work_hour || 0));
            const worktime_payment = parseInt(Math.abs(data.fee_normal_hourly || 0));
            const overtime = parseInt(Math.abs(data.overtime_work_hour_spv || 0));
            const overtime_payment = parseInt(Math.abs(data.fee_overtime_hourly || 0));
            const total_fee = ( worktime_payment ) + ( overtime * overtime_payment );
            return this.formatCurrency(parseInt(total_fee));
        },
        async updateData() {
            const overtime_work_hour_spv = this.selected_data.overtime_work_hour_spv ? parseInt(this.selected_data.overtime_work_hour_spv) : 0;
            const data = {
                id: this.selected_data.id,
                checkin_time: this.selected_data.checkin_time,
                checkout_time: this.selected_data.checkout_time,
                normal_work_hour: this.selected_data.normal_work_hour,
                overtime_work_hour_spv,
                absent_hour: this.selected_data.absent_hour,
                leaves_hour: this.selected_data.leaves_hour,
                attendance_method: this.selected_data.attendance_method,
                is_replacement_day: this.selected_data.is_replacement_day || false,
                is_half_day: this.selected_data.is_half_day || false
            };
            const response = await this.updateRecap(data);
            if (response.status == 'OK') {
                await this.getRecaps(this.meta);
                this.hideModal('confirmation-heads-up');
            }
        },
        async lockData() {
            const overtime_work_hour_spv = this.selected_data.overtime_work_hour_spv ? parseInt(this.selected_data.overtime_work_hour_spv) : 0;
            const data = {
                id: this.selected_data.id,
                checkin_time: this.selected_data.checkin_time,
                checkout_time: this.selected_data.checkout_time,
                normal_work_hour: this.selected_data.normal_work_hour,
                overtime_work_hour_spv,
                absent_hour: this.selected_data.absent_hour,
                leaves_hour: this.selected_data.leaves_hour,
                attendance_method: this.selected_data.attendance_method,
                is_replacement_day: this.selected_data.is_replacement_day || false,
                is_half_day: this.selected_data.is_half_day || false
            };
            const response = await this.updateRecap(data);
            if (response.status == 'OK') {
                await this.getRecaps(this.meta);
                this.hideModal('confirmation-heads-up');
                this.showModal('success-edit');
            }
        },
        acceptConfirmationEdit() {
            this.hideModal('confirmation-edit-box');
            this.showModal('show-detail');
        },
        async acceptConfirmationEdit2() {
            const overtime_work_hour_spv = this.selected_data.overtime_work_hour_spv ? parseInt(this.selected_data.overtime_work_hour_spv) : 0;
            const data = {
                id: this.selected_data.id,
                checkin_time: this.selected_data.checkin_time,
                checkout_time: this.selected_data.checkout_time,
                normal_work_hour: this.selected_data.normal_work_hour,
                overtime_work_hour_spv,
                absent_hour: this.selected_data.absent_hour,
                leaves_hour: this.selected_data.leaves_hour,
                attendance_method: this.selected_data.attendance_method,
                is_replacement_day: this.selected_data.is_replacement_day || false,
                is_half_day: this.selected_data.is_half_day || false
            };
            let response = await this.updateRecap(data);
            if (response.status == 'OK') {
                await this.getRecaps(this.meta);
                this.hideModal('confirmation-edit-box-2');
                this.showModal('success-edit');
            } else {
                this.hideModal('confirmation-edit-box-2');
            }
        },
        declineConfirmationEdit() {
            this.hideModal('confirmation-edit-box');
            this.showModal('confirmation-heads-up');
        },
        declineConfirmationEdit2() {
            this.hideModal('confirmation-edit-box-2');
            this.showModal('show-detail');
        },
        async updateDataConfirm() {
            await window.UIkit.modal('#show-detail').hide();
            this.showModal('confirmation-edit-box-2');
        },
        calculateTotalWorkTime(normal, overtime) {
            const normal_time = parseInt(Math.abs(normal)) || 0;
            const overtime_time = parseInt(Math.abs(overtime)) || 0;
            return normal_time + overtime_time;
        },
        adjustWorktime(e, type) {
            let checkin = '';
            let checkout = '';

            switch(type) {
            case 'check-in':
                checkin = e.target.value;
                checkout = this.selected_data.checkout_time;
                break;
            case 'check-out':
                checkin = this.selected_data.checkin_time;
                checkout = e.target.value;
                break;
            }

            const checkin_time = new Date(checkin);
            const checkout_time = new Date(checkout);

            if (checkin_time > checkout_time) {
                if(type == 'check-in') {
                    return notificationDangerCustom('Check in time must be lesser than check out time');
                } else
                    return notificationDangerCustom('Check out time must be greater than check in time');
            }

            const time_dif = (checkout_time - checkin_time) / 3600000; // milisecond
            this.selected_data.checkin_time = checkin;
            this.selected_data.checkout_time = checkout;
            this.selected_data.normal_work_hour = Math.floor(time_dif);
        },
        adjustCheckOutTime(value) {
            const checkin_time = new Date(this.selected_data.checkin_time);
            const checkout_time = new Date(value);

            if (checkin_time > checkout_time) {
                this.timeIsInvalid = true;
                return notificationDangerCustom('Check out time must be greater than check in time');
            }

            this.timeIsInvalid = false;
            const time_dif = (checkout_time - checkin_time) / 3600000; // milisecond
            this.selected_data.checkout_time = value;
            this.selected_data.normal_work_hour = Math.floor(time_dif);
        },
        adjustCheckInTime(value) {
            const checkin_time = new Date(value);
            const checkout_time = new Date(this.selected_data.checkout_time);

            if (checkin_time > checkout_time) {
                this.timeIsInvalid = true;
                return notificationDangerCustom('Check in time must be lesser than check out time');
            }

            this.timeIsInvalid = false;
            const time_dif = (checkout_time - checkin_time) / 3600000; // milisecond
            this.selected_data.checkin_time = value;
            this.selected_data.normal_work_hour = Math.floor(time_dif);
        },
        checkUpdatedBy(data) {
            if (data.employer_hr != null) {
                return data.employer_hr.fullname;
            } else if (data.employer_spv != null) {
                return data.employer_spv.fullname;
            } else {
                return '-';
            }
        },
        async downloadNewExcelDaily() {
            let all_recaps = await this.getAllRecaps(this.meta);
            let non_grouped_recaps = await this.getAllNonGroupedRecaps(this.meta);

            //format time in frontend for excel file
            for (let item in non_grouped_recaps) {
                non_grouped_recaps[item].date = non_grouped_recaps[item].date !== '-' ? formatter.dateComplete(non_grouped_recaps[item].date) : '-';
                non_grouped_recaps[item].checkin_time = non_grouped_recaps[item].checkin_time !== '-' ? formatter.timeComplete(non_grouped_recaps[item].checkin_time) : '-';
                non_grouped_recaps[item].checkout_time= non_grouped_recaps[item].checkout_time !== '-' ? formatter.timeComplete(non_grouped_recaps[item].checkout_time) : '-';
            }
            excelDownloader(all_recaps, this.generateFileName());
            excelDownloader(non_grouped_recaps, this.generateFileNameFull());
        },
        async downloadNewExcelMonthly() {
            if (this.userReport) {
                if (this.userName != '') {
                    this.meta.worker_name = this.userName;
                } else {
                    return notificationDangerCustom('User must be selected!');
                }
            }
            const weekly_recaps = await this.getWeeklyReportByMonth(this.meta);
            excelDownloader(weekly_recaps, this.generateWeeklyFileName());
            this.resetUserReport();
            this.hideModal('month-filter');
        },
        async downloadNewDaytoDayExcelMonthly() {
            if (this.userReport) {
                if (this.userName != '') {
                    this.meta.worker_name = this.userName;
                } else {
                    return notificationDangerCustom('User must be selected!');
                }
            }
            this.reportMonthly = false;
            let weekly_recaps = await this.getDailyReportByMonth(this.meta);
            excelDownloader(weekly_recaps, this.generateMonthlyFileName());
            this.resetUserReport();
            this.hideModal('month-filter');
        },
        resetUserReport() {
            this.userReport = false;
            this.meta.worker_name = '';
            this.userName = '';
        },
        async checkRecap() {
            this.salary_data =  await this.checkRecaps({recaps: this.recaps.docs});
            if (this.salary_data.status == 'error') {
                this.showModal('warning-modal');
            } else {
                this.showModal('salary-modal');
            }
        },
        async createSalaryBatch() {
            const response = await this.postCreateBatch({name: this.formSalary.name, recaps: this.recaps.docs});
            if (response && response.status === 'OK') {
                notificationSuccess('Salary batch created.');
                this.hideModal('salary-modal');
                await this.getRecaps(this.meta);
            } else {
                notificationDangerCustom('Failed to create salary batch.');
            }
        },
        consist(user_roles, value){
            return value.some(i => user_roles.includes(i));
        },
    }
};
</script>

<style scoped>
div{
   margin-bottom: 10px;
}
.card-title-style{
   color: #0ABAB5;
   font-size: 30px;
   font-style: 'bold';
   font-family: 'Roboto';
}
.location-header{
    font-family: 'Roboto';
    color: #FEBE10;
    font-size: 20px;
}
thead{
    background-color: #0ABAB5;
}
th{
    color: #ffffff;
}
td{
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: 400;
    color: #000000;
}
.reset-filter{
   font-family: 'Roboto';
   color: #979797;
   text-decoration: underline;
   font-size: 16px;
   cursor: pointer;
   margin: 0;
   padding: 0;
}
.report-download{
    font-family: 'Roboto';
    color: #5FD855;
    font-size: 20px;
}
.action-button{
    width: 100px;
    margin-bottom: 10px;
    margin-left: 5px;
    height: 40px;
    color: #ffffff;
}
</style>
